// mutations/createUserMutation.ts
import { gql, MutationHookOptions, useMutation } from '@apollo/client';

const MUTATION = gql`
  mutation createUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
    }
  }
`;

export type Variables = {
    input: {
        email: string;
        roleId: string;
    };
};

export type Response = {
    createUser: {
        id: string;
    };
};

export const useCreateUserMutation = (
    options: MutationHookOptions<Response, Variables>,
) => useMutation<Response, Variables>(MUTATION, options);
